<template>
  <div>
    <v-container grid-list-lg fluid>
        <v-layout row wrap>
            <v-flex lg12 md12 sm12>
                <v-card>
                    <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                    <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                        <template v-slot:item="{ item }">
                            <tr>
                                <td>{{ item.product_code }}</td>
                                <td>{{ item.name }}</td>
                                <td>{{ item.deactive_at | display_date }}</td>
                                <td class="text-end">{{ item.total_qty | currency }}</td>
                                <td class="text-end">{{ item.total_store | currency }}</td>
                                <td class="text-end">{{ item.total_remain | currency }}</td>
                                <td class="text-center"><v-icon medium :color="item.late_report_check ? 'green' : 'gray'" @click="updateItem({id: item.id, late_report_check: !item.late_report_check})">circle</v-icon></td>
                                <td>
                                    <v-edit-dialog :return-value.sync="item.late_report_shipment" large lazy persistent @save="updateItem({id: item.id, late_report_shipment: item.late_report_shipment || '', order_ids: item.order_ids})">
                                        <div v-bind:style="{'color': item.late_report_shipment == 'khong_ve_nua' ? 'red' : ''}">{{ item.late_report_shipment | display_value(order_shipment_status) }}</div>
                                        <template v-slot:input>
                                            <v-select v-model="item.late_report_shipment" label="Tình trạng" :items="order_shipment_status" item-text="name" item-value="value" single-line autofocus clearable></v-select>
                                        </template>
                                    </v-edit-dialog>
                                </td>
                                <td class="text-end">
                                    <v-edit-dialog :return-value.sync="item.late_report_note" large lazy persistent @save="updateItem({id: item.id, late_report_note: item.late_report_note})">
                                        <div>{{ item.late_report_note }}</div>
                                        <template v-slot:input>
                                            <v-text-field v-model="item.late_report_note" label="Ghi chú" single-line autofocus></v-text-field>
                                        </template>
                                    </v-edit-dialog>
                                </td>
                                <td class="text-center"><a href="javascript:void(0)" @click="showOrderList(item.order_ids)">Chi tiết</a></td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
    <v-dialog v-model="dialogOrders" max-width="90%">
        <v-card>
            <v-card-title>
                <span class="title">Danh sách đơn hàng</span>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1 white--text" @click="dialogOrders = false">Đóng</v-btn>
            </v-card-title>
            <v-card-text>
                <order-list :order_ids="order_ids"></order-list>
            </v-card-text>
        </v-card>
    </v-dialog>
    </div>
</template>
<script>
import { mapState } from "vuex";
import configs from "@/configs";
import Filtering from "@/components/Filtering";
import OrderList from "@/views/Orders/list";
import _ from "lodash";
export default {
    components: {
        "hpo-filter": Filtering,
        "order-list": OrderList,
    },
    data() {
        return {
            dialogOrders: false,
            order_ids: [],
            viewName: "bao-cao-cham-phat",
            pagination: {...configs.PAGINATION, sortBy: ["id"]},
            items_per_page: {...configs.ITEMS_PER_PAGE},
            filterConditions: [],
            quickFilterConditions: [],
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
    },
    computed: {
        ...mapState({
            items: state => state.late_report.all.data,
            total_rows: state => state.late_report.all.total,
            loading: state => state.late_report.loading,
        }),
        headers() {
            return [{
                    text: "Mã sản phẩm",
                    value: "product_code",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Tên sản phẩm",
                    value: "name",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Ngày đóng đơn",
                    value: "deactive_at",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Tổng đặt",
                    value: "total_qty",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tổng phát",
                    value: "total_store",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Thiếu",
                    value: "total_remain",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Còn về",
                    value: "late_report_check",
                    filterable: true,
                    values: [{'value': 0, 'name': 'Không'}, {'value': 1, 'name': 'Có'}],
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "Tình trạng",
                    value: "late_report_shipment",
                    filterable: true,
                    values: this.order_shipment_status,
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "Ghi chú",
                    value: "late_report_note",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Thao tác",
                    value: "",
                    align: "center",
                    sortable: false,
                    filterable: false
                }
            ]
        },
        order_shipment_status() {
            return _.filter(configs.ORDER_SHIPMENT_STATUS, p => {
                return p.value == 'khong_ve_nua' || p.value == 'hang_ve_du' || p.value == 'hang_ve_thieu'
            })
        },
    },
    methods: {
        filter_data: function () {
            var param = {
                pagination: this.pagination,
                filter: [...this.filterConditions],
                quickFilter: this.quickFilterConditions
            };
            this.$store.dispatch("late_report/getList", param);
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        showOrderList(ids) {
            this.order_ids = ids.split(',');
            this.dialogOrders = true;
        },
        updateItem(item) {
            this.$store.dispatch("products/setDetail", {data: {...item, 'action': 'update_by_report'}, id: item.id});
        }
    },
    mounted() {
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA");
    }
};
</script>